import type {
  TMessageListState,
  TNewMessageState,
  TMessageUnreadState,
  TMessageStatusState,
} from "./message.types";

export const MAX_MESSAGES_ON_SCREEN = 25;

export const messageListInitialState: TMessageListState = {
  error: false,
  fetched: false,
  chatId: undefined,
  loading: false,
  pagination: {
    start: 0,
    end: MAX_MESSAGES_ON_SCREEN,
    hasOlderMessages: false,
    hasOlderMessagesToFetch: false,
    fetchingOlderMessages: false,
    loadedOlderMessages: false,
  },
  newMessages: [],
  source: [],
};

export const newMessageInitialState: TNewMessageState = {
  error: false,
  fetched: false,
  loading: false,
  chatId: undefined,
  chatType: undefined,
  itsMyMessage: false,
  source: [],
};

export const messageUnreadInitialState: TMessageUnreadState = {
  fetched: false,
  source: null,
};

export const messageStatusInitialState: TMessageStatusState = {
  error: false,
  fetched: false,
  loading: false,
  source: [],
};
